(function () {
  'use strict';
  const names={accessories:'Accessories',electronics:'Other Electronics',server:'Server Parts','new-arrivals':'New Arrivals','as-is':'As-Is Items'};
  const types={cables:'Cables & Adapters',trays:'Storage & Shipping Trays',mounts:'Mounts & Remotes',other:'Other Accessories'};
  function classify(data,group,now=Date.now()){
    const title=String(data.title||''),cat=String(data.catalogCategory||'');
    const brand=String(data.vendor||'').trim()||'Unspecified brand';
    if(group==='accessories'){
      if(cat&&cat!=='accessories')return null;
      const type=/\b(?:cpu|ram|memory)\b/i.test(title)&&/\btray\b/i.test(title)?'trays':
        /\b(?:mount|bracket|remote control)\b/i.test(title)?'mounts':/\b(?:cable|adapter|adaptor)\b/i.test(title)?'cables':'other';
      return cat==='accessories'||type!=='other'?{type,brand}:null;
    }
    if(group==='electronics')return cat==='electronics'||(!cat&&/\b(?:transformer|flood\s*light)\b/i.test(title))?{type:'all',brand}:null;
    if(group==='server')return cat==='server'||/\b(?:server|poweredge|thinkserver|proliant)\b/i.test(title)?{type:'all',brand}:null;
    if(group==='as-is')return /\bas[\s-]+is\b|for parts|not working/i.test(title)||/for parts|not working/i.test(String(data.condition||''))?{type:'all',brand}:null;
    if(group==='new-arrivals'){
      const added=Date.parse(data.catalogAddedAt||data.publishedAt||'');
      return Number.isFinite(added)&&added<=now&&added>=now-14*86400000?{type:'all',brand,added}:null;
    }
    return null;
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={classify};
  if(typeof document==='undefined')return;
  window.tekExtraCatalog={classify};
  if(window.tekExtraLoaded)return;window.tekExtraLoaded=true;
  function init(root){
    root.querySelectorAll('[data-extra-picker]').forEach(panel=>{
      if(panel.dataset.ready)return;panel.dataset.ready='true';
      const group=panel.dataset.extraPicker;
      const trigger=root.querySelector('[data-extra-trigger="'+group+'"]');
      if(!trigger)return;
      const type=panel.querySelector('[data-extra-type]'),brand=panel.querySelector('[data-extra-brand]');
      const search=panel.querySelector('[data-extra-search]'),results=panel.querySelector('[data-extra-results]');
      const status=panel.querySelector('[data-extra-status]'),retry=panel.querySelector('[data-extra-retry]');
      const browse=panel.querySelector('[data-extra-browse]');
      let entries=[],loading=false;
      function brands(){
        brand.replaceChildren(new Option('All brands',''));
        const counts=new Map();
        entries.filter(e=>!type?.value||e.type===type.value).forEach(e=>counts.set(e.brand,(counts.get(e.brand)||0)+1));
        [...counts].sort(([a],[b])=>a.localeCompare(b)).forEach(([name,n])=>brand.add(new Option(name+' ('+n+')',name)));
        brand.disabled=!counts.size;
      }
      function refresh(){
        results.replaceChildren();
        const key=search.value.toLowerCase().replace(/[^a-z0-9]/g,'');
        const filtered=entries.filter(e=>(!type?.value||e.type===type.value)&&(!brand.value||e.brand===brand.value)&&
          (!key||[e.template.dataset.title,e.template.dataset.model].some(s=>String(s||'').toLowerCase().replace(/[^a-z0-9]/g,'').includes(key))));
        for(const entry of filtered)results.append(document.importNode(entry.template.content,true));
        status.textContent=filtered.length?filtered.length+' '+(filtered.length===1?'listing':'listings')+' in stock.':
          entries.length?'No items match these filters. Try another type, brand or search.':'No '+names[group].toLowerCase()+' are currently in stock.';
      }
      async function load(){
        if(loading)return;loading=true;entries=[];results.replaceChildren();retry.hidden=true;
        if(type){type.value='';type.disabled=true;}search.value='';search.disabled=true;brand.disabled=true;browse.disabled=true;
        panel.setAttribute('aria-busy','true');status.textContent='Loading '+names[group].toLowerCase()+'…';
        try{
          let url=new URL(panel.dataset.feedUrl,location.origin);url.searchParams.set('section_id','tek-memory-feed');
          const pages=new Set(),handles=new Set(),loaded=[];
          while(url){
            if(url.origin!==location.origin||pages.has(url.href))throw Error('Invalid inventory page');
            pages.add(url.href);
            const response=await fetch(url,{signal:AbortSignal.timeout(15000),cache:'no-store'});
            if(!response.ok)throw Error('Inventory unavailable');
            const doc=new DOMParser().parseFromString(await response.text(),'text/html');
            if(!doc.querySelector('[data-memory-feed]'))throw Error('Invalid inventory response');
            for(const template of doc.querySelectorAll('template[data-memory-item]')){
              if(handles.has(template.dataset.handle))continue;handles.add(template.dataset.handle);
              const info=classify(template.dataset,group);if(info)loaded.push({...info,template});
            }
            const next=doc.querySelector('[data-memory-next]');
            url=next?new URL(next.getAttribute('href'),url):null;
            if(url)url.searchParams.set('section_id','tek-memory-feed');
          }
          entries=group==='new-arrivals'?loaded.sort((a,b)=>b.added-a.added):loaded;
          if(type)type.disabled=false;search.disabled=false;browse.disabled=false;brands();refresh();
        }catch{status.textContent='We could not load inventory. Please try again.';retry.hidden=false;}
        finally{loading=false;panel.removeAttribute('aria-busy');}
      }
      type?.addEventListener('change',()=>{brands();refresh();});
      brand.addEventListener('change',refresh);search.addEventListener('input',refresh);
      browse.addEventListener('click',()=>{if(type)type.value='';search.value='';brands();refresh();});
      retry.addEventListener('click',load);
      function close(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus();}
      trigger.setAttribute('aria-controls',panel.id);trigger.setAttribute('aria-expanded','false');
      root.addEventListener('tp:picker-open',e=>{if(e.detail!==panel){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}});
      trigger.addEventListener('click',e=>{
        e.preventDefault();if(!panel.hidden){close();return;}
        root.dispatchEvent(new CustomEvent('tp:picker-open',{detail:panel}));
        panel.hidden=false;trigger.setAttribute('aria-expanded','true');
        panel.querySelector('h3').focus({preventScroll:true});panel.scrollIntoView({block:'start',behavior:'instant'});load();
      });
      panel.querySelector('[data-extra-close]').addEventListener('click',close);
      panel.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
    });
  }
  const scan=()=>document.querySelectorAll('[data-category-gallery]').forEach(init);
  scan();document.addEventListener('shopify:section:load',scan);
})();
